import {
	CLEAR_IMAGEUPLOAD,
	IMAGE_SELECTING,
	IMAGE_UNSELECTING,
	IMAGE_UPLOADED,
	IMAGE_UPLOADING,
} from "../actions/types";
const initialState = {
	isUploading: false,
	isUpLoaded: false,
	file: {},
	response: {},
};
export default function (state = initialState, action) {
	switch (action.type) {
		case IMAGE_SELECTING:
			return {
				...state,
				isUploading: false,
				isUpLoaded: false,
				isSelected: true,
				file: action.payload,
			};
		case IMAGE_UNSELECTING:
			return {
				...state,
				isUploading: false,
				isUpLoaded: false,
				isSelected: true,
				file: null,
			};
		case IMAGE_UPLOADING:
			return {
				...state,
				isSelected: true,
				isUploading: true,
				isUpLoaded: false,
				response: {},
			};
		case IMAGE_UPLOADED:
			return {
				...state,
				isSelected: false,
				isUploading: false,
				isUpLoaded: true,
				response: action.payload,
			};
		case CLEAR_IMAGEUPLOAD:
			return {
				...state,
				isUploading: false,
				isUpLoaded: false,
				file: null,
				response: {},
			};

		default:
			return state;
	}
}
